module.exports = __webpack_public_path__ + "img/서브_책임감.c0815753.svg";